import { useState } from "react"
import { handleExtraMove } from "./configs"
import { FormControlLabel, Switch } from "@mui/material"

const OptionComponent = (props) => {
    const {
        option,
        record
    } = props

    const [optionChange, setOptionChange] = useState(option)

    return (
        <FormControlLabel
            control={
                <Switch
                    checked={optionChange}
                    onChange={(e) => {
                        handleExtraMove(e, record)
                        setOptionChange(!optionChange)
                    }}
                />
            }
        />
    )
}

export default OptionComponent